<template>
    <span
        class="price-currency"
        :class="getBemModifiers()"
    >{{ currency }}</span>
</template>

<script>
export default {
    name: 'PriceCurrency',
    props: {
        /**
         *  Price currency
         */
        currency: {
            type: String,
            default: 'zł',
        },
    },
};
</script>

<style lang="scss">
    .price-currency {
        font-family: $goodHomeFontFamily;
        font-size: 12px;
        font-weight: $font-weight-regular;

        &--bold {
            font-weight: $font-weight-bold;
        }

        &--grid-order {
            color: $color-slate;
            font-size: 18px;
            line-height: 18px;
            font-weight: $font-weight-bold;
        }

        &--font-small {
            font-size: 14px;
        }

        &--font-normal {
            font-size: 18px;
        }

        &--font-large {
            font-size: 22px;
        }

        &--font-largest {
            font-size: 24px;
        }

        &--color-blue {
            color: $color-castoBlue;
        }
    }
    @media (min-width: $mf-breakpoint-tablet) {
        .price-currency {
            &--font-small {
                font-size: 20px;
            }
        }
    }
</style>
